import { useEffect, useRef } from "react";
import { isSelfHandledRowPart } from "../utils/documentMoveDrag";

/**
 * Records where the press that starts a drag landed.
 *
 * A row is draggable as a whole, so per the HTML drag-and-drop model
 * `dragstart` fires at the draggable row root no matter which descendant was
 * pressed — `event.target` in that handler is the row, and searching it with
 * `closest()` looks at the row's ANCESTORS, never at the checkbox or actions
 * cell under the pointer. Press-and-drag on those would therefore start a move.
 *
 * The pointer-down that precedes the drag is the only event that still knows
 * the real origin, so latch it (capture phase, so a row's own handler can't
 * stop it first) and let `dragstart` read the verdict.
 */
export function useMoveDragOrigin() {
  const pressedSelfHandledPart = useRef(false);

  useEffect(() => {
    const record = (event: PointerEvent) => {
      pressedSelfHandledPart.current = isSelfHandledRowPart(event.target);
    };
    document.addEventListener("pointerdown", record, true);
    return () => document.removeEventListener("pointerdown", record, true);
  }, []);

  return pressedSelfHandledPart;
}
